import {
  Directive,
  Input,
  ElementRef,
  Output, EventEmitter, SimpleChanges, OnInit
} from '@angular/core';

import {StsCmsService} from '../../services/sts-cms-service.service';
import { OnChanges } from '@angular/core';

@Directive({
  selector: '[app-sts-cms-txt]'
})
export class StsCmsTxtDirective implements OnInit, OnChanges {
  @Output() renderingComplete = new EventEmitter<boolean>(false);
  @Input() key: string;
  @Input() ignore: boolean;
  @Input() alttext: string;
  @Input() context: string;
  _isBusy = false;

  private retries = 0;

  constructor(private el: ElementRef,
              private cmsService: StsCmsService) { }

  fnLoadThisText(txtKey: string): void {
    this.el.nativeElement.cssClass += 'dynamic-text' ;
    this.el.nativeElement.setAttribute('sts-key', txtKey);

    if (this._isBusy) { return; }
    this._isBusy = true;

    this.cmsService.getText(txtKey).subscribe( 
      a => {
        this.el.nativeElement.cssClass += 'dynamic-text-loaded';
        if (a && !this.ignore) {
          this.el.nativeElement.innerHTML = a;
        }        
        if (a == null && this.alttext != undefined) {
          this.el.nativeElement.innerHTML = this.alttext;
        }

        this.renderingComplete.emit(true);
        this._resetValue();
      },
      e => {
        if (++this.retries < 2) {
          this.fnLoadThisText(txtKey);
        } else {
          this._resetValue();
        }
      });
  }

  private _resetValue() {
    this.retries = 0;
    this._isBusy = false;
  }

  ngOnInit() {
    this.loadCmsText();
  }

  ngOnChanges(changes: SimpleChanges) {
    const key = changes['key'];

    // this will trigger when the key value is changed and it's not the first value assigned
    if (!key.isFirstChange() && key.previousValue !== key.currentValue) {
      this.loadCmsText();
    }
  }

  private loadCmsText() {
    const txtKey = this.key || this.el.nativeElement.getAttribute('key');

    if (txtKey) {
      this.fnLoadThisText(txtKey);
    } else {
      console.log('>> invalid use of cms-txt', this.el.nativeElement);
    }
  }
}
